/**
 * `RequestCreditsDialog`'s own copy (`../capacity/RequestCredits.tsx`); the state labels and the
 * open-request view read the shared `tt` catalogue (`src/app/tenant/i18n`).
 */

import { defineCatalogue } from '../../../i18n';

export const requestCatalogue = defineCatalogue(
  {
    'withdraw.title': 'Retirar o pedido?',
    'withdraw.body': 'O operador deixa de vê-lo. Você pode pedir de novo depois.',
    'withdraw.confirm': 'Retirar',
    'quanto.label': 'Quanto',
    'quanto.option': '{amount} mil',
    'quanto.other': 'Outro',
    'quanto.other.label': 'Quantos créditos',
    'quanto.other.invalid': 'Informe um número inteiro de créditos, maior que zero.',
    'context.label': 'Para quê (opcional)',
    'context.balance': 'Saldo disponível',
    'context.rate': 'Gasto por dia',
    'context.runway': 'Cobre a coleta até',
  },
  {
    'withdraw.title': 'Withdraw the request?',
    'withdraw.body': 'The operator stops seeing it. You can ask again later.',
    'withdraw.confirm': 'Withdraw',
    'quanto.label': 'Amount',
    'quanto.option': '{amount}k',
    'quanto.other': 'Other',
    'quanto.other.label': 'How many credits',
    'quanto.other.invalid': 'Enter a whole number of credits, above zero.',
    'context.label': 'Reason (optional)',
    'context.balance': 'Available balance',
    'context.rate': 'Spent per day',
    'context.runway': 'Covers collection until',
  },
);

export const rm = requestCatalogue.t;
